import universalImport from 'babel-plugin-universal-import/universalImport';
import universal from 'react-universal-component';
import path from 'path';
import LazyComponent from './LazyComponent';

const importResource = universalImport({
    chunkName: () => 'LazyCAMChunks',
    path: () => path.join(__dirname, './CAMDashboardConnect'),
    resolve: () => require.resolveWeak('./CAMDashboardConnect'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: "LazyCAMChunks" */ './CAMDashboardConnect'), // css name
        ]).then((proms) => proms[0]),
});

export default universal(importResource, LazyComponent.loaderResource);
